import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import { DashboardState } from './treatment.reducer';
import { FollowupPackageType, InterimScanOption, TreatmentModel } from '../models/treatment.model';
import { ProductKey } from 'libs/product/src/lib/models/product.model';

export enum TreatmentActionTypes {
  TreatmentRequested = '[Treatment Resolver] Treatment Requested',
  TreatmentsRequested = '[Treatments Resolver] Treatments Requested',
  TreatmentsLoaded = '[Treatments API] Treatments Loaded',
  TreatmentSelected = '[Treatments Component] Treatment Selected',
  LoadTreatments = '[Treatment] Load Treatments',
  AddTreatment = '[Treatment] Add Treatment',
  UpsertTreatment = '[Treatment] Upsert Treatment',
  UpsertTreatmentOnDb = '[Treatment] Upsert Treatment on DB',
  AddTreatments = '[Treatment] Add Treatments',
  UpsertTreatments = '[Treatment] Upsert Treatments',
  UpdateTreatment = '[Treatment] Update Treatment',
  UpdateTreatments = '[Treatment] Update Treatments',
  DeleteTreatment = '[Treatment] Delete Treatment',
  DeleteTreatments = '[Treatment] Delete Treatments',
  ClearTreatments = '[Treatment] Clear Treatments',
  OrderNextPackage = '[Treatment] Order Next Package',
  SaveDashboardState = '[Treatment Dashboard] Save Dashboard State',
  TreatmentHandlingUpdated = '[Treatment Release] Update Product Handling',
  AssignAndGoToTreatment = '[Treatment Dashboard] Assign and Go to Treatment',
  InitiateSubsequentOrder = '[Treatment] Initiate Subsequent Order',
  SubmitComplaint = '[Treatment] Submit Complaint',
  SubmitComplaintSuccess = '[Treatment] Submit Complaint Success',
  SubmitReleaseRequest = '[Treatment] Submit Release Request',
  SubmitReleaseRequestOrcadent = '[Treatment] Submit Release Request Orcadent',
  RequestRefinement = '[Treatment] Request Refinement',
  RequestRefinementRelease = '[Treatment] Request Refinement Release',
  ReleaseRefinementRequest = '[Treatment] Release Refinement Request',
  RejectRefinementRequest = '[Treatment] Reject Refinement Request'
}

export class TreatmentRequested implements Action {
		readonly type = TreatmentActionTypes.TreatmentRequested;
		constructor(public payload: { id: string }) { }
}
export class TreatmentsRequested implements Action {
	readonly type = TreatmentActionTypes.TreatmentsRequested;
}
export class TreatmentsLoaded implements Action {
	readonly type = TreatmentActionTypes.TreatmentsLoaded;
	constructor( public payload: TreatmentModel[]) {}
}
export class TreatmentSelected implements Action {
	readonly type = TreatmentActionTypes.TreatmentSelected;
	constructor( public payload: string) {}
}
export class TreatmentHandlingUpdated implements Action {
	readonly type = TreatmentActionTypes.TreatmentHandlingUpdated;
	constructor( public payload: {}) {}
}
export class LoadTreatments implements Action {
  readonly type = TreatmentActionTypes.LoadTreatments;

  constructor(public payload: { treatments: TreatmentModel[] }) {}
}

export class AddTreatment implements Action {
  readonly type = TreatmentActionTypes.AddTreatment;

  constructor(public payload: { treatment: TreatmentModel }) {}
}

export class UpsertTreatment implements Action {
  readonly type = TreatmentActionTypes.UpsertTreatment;

  constructor(public payload: { treatment: TreatmentModel }) {}
}
export class UpsertTreatmentOnDb implements Action {
	readonly type = TreatmentActionTypes.UpsertTreatmentOnDb;

	constructor(public payload: { treatmentId: string, diff: any }) {}
}
export class AddTreatments implements Action {
  readonly type = TreatmentActionTypes.AddTreatments;

  constructor(public payload: { treatments: TreatmentModel[] }) {}
}

export class UpsertTreatments implements Action {
  readonly type = TreatmentActionTypes.UpsertTreatments;

  constructor(public payload: { treatments: TreatmentModel[] }) {}
}

export class UpdateTreatment implements Action {
  readonly type = TreatmentActionTypes.UpdateTreatment;

  constructor(public payload: { treatment: Update<TreatmentModel> }) {}
}

export class UpdateTreatments implements Action {
  readonly type = TreatmentActionTypes.UpdateTreatments;

  constructor(public payload: { treatments: Update<TreatmentModel>[] }) {}
}

export class DeleteTreatment implements Action {
  readonly type = TreatmentActionTypes.DeleteTreatment;

  constructor(public payload: { id: string }) {}
}

export class DeleteTreatments implements Action {
  readonly type = TreatmentActionTypes.DeleteTreatments;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTreatments implements Action {
  readonly type = TreatmentActionTypes.ClearTreatments;
}
export class OrderNextPackage implements Action {
	readonly type = TreatmentActionTypes.OrderNextPackage;
	constructor(public payload: {treatmentId: string, packageType: FollowupPackageType, interimScanOption: InterimScanOption}) {}
}

export class SaveDashboardState implements Action {
	readonly type = TreatmentActionTypes.SaveDashboardState;
	constructor( public payload: {tab: number, state: DashboardState}) {}
}

export class AssignAndGoToTreatment implements Action {
	readonly type = TreatmentActionTypes.AssignAndGoToTreatment;
	constructor(public payload: {
		treatment: TreatmentModel,
		username: string,
		tab: number,
		state: DashboardState,
	}) { }
}

export class InitiateSubsequentOrder implements Action {
	readonly type = TreatmentActionTypes.InitiateSubsequentOrder;
	constructor(public payload: {
		productKey: ProductKey,
		patientId: string,
		treatmentId: string,
	}) { }
}

export class SubmitComplaint implements Action {
	readonly type = TreatmentActionTypes.SubmitComplaint;
	constructor(public payload: { treatment: TreatmentModel }) { }
}

export class SubmitComplaintSuccess implements Action {
	readonly type = TreatmentActionTypes.SubmitComplaintSuccess;
	constructor(public payload: { treatment: TreatmentModel }) { }
}


export class SubmitReleaseRequest implements Action {
	readonly type = TreatmentActionTypes.SubmitReleaseRequest;
	constructor(public payload: { treatmentId, releaseRequest: {releaseData, totalPlannedSteps, upgrade?} }) { }
}

export class SubmitReleaseRequestOrcadent implements Action {
	readonly type = TreatmentActionTypes.SubmitReleaseRequestOrcadent;
	constructor(public payload: { treatmentId }) { }
}

export class RequestRefinement implements Action {
	readonly type = TreatmentActionTypes.RequestRefinement;
	constructor(public payload: {treatmentId: string, comment?: string}) {}
}

export class RequestRefinementRelease implements Action {
	readonly type = TreatmentActionTypes.RequestRefinementRelease;
	constructor(public payload: {treatmentId: string, plannedAligners: number}) {}
}
export class ReleaseRefinementRequest implements Action {
	readonly type = TreatmentActionTypes.ReleaseRefinementRequest;
	constructor(public payload: {treatmentId: string}) {}
}

export class RejectRefinementRequest implements Action {
	readonly type = TreatmentActionTypes.RejectRefinementRequest;
	constructor(public payload: {treatmentId: string}) {}
}


export type TreatmentActions =
 | TreatmentRequested
 | TreatmentsRequested
 | TreatmentSelected
 | TreatmentsLoaded
 | LoadTreatments
 | AddTreatment
 | UpsertTreatment
 | UpsertTreatmentOnDb
 | AddTreatments
 | UpsertTreatments
 | UpdateTreatment
 | UpdateTreatments
 | DeleteTreatment
 | DeleteTreatments
 | ClearTreatments
 | OrderNextPackage
 | SaveDashboardState
 | TreatmentHandlingUpdated
 | AssignAndGoToTreatment
 | InitiateSubsequentOrder
 | SubmitComplaint
 | SubmitComplaintSuccess
 | SubmitReleaseRequest
 | SubmitReleaseRequestOrcadent
 | RequestRefinement
 | RequestRefinementRelease
 | ReleaseRefinementRequest
 | RejectRefinementRequest;
